<script setup lang="ts">
import { StrapiLocale } from '@nuxtjs/strapi/dist/runtime/types';
import { PostSmall } from '@/api/models';
import { Tag } from '@/api/models/Tag';
import { WithLocalizations } from '@/utils/types';
import { useSeoSlugs } from '@/store/useSeoSlugs';
const route = useRoute();
const tagName = route.params.tagName;
const { locale, t } = useI18n();
const { find } = useStrapi()


const tagDataRequest = useAsyncData('tag', () => find<WithLocalizations<Tag>>('tags', {
    filters: { tagName },
    populate: ['localizations'],
    locale: locale.value as StrapiLocale
}));

const articlesRequest = useAsyncData('posts', () => find<PostSmall>('posts', {
    sort: 'desc',
    publicationState: 'live',
    filters: { tags: { tagName } },
    populate: ['thumbnail', 'tags', 'author'],
    fields: ['thumbnail', 'author', 'tags', 'title', 'slug', 'thumbnail_bg_color', 'publishedAt', 'description', 'locale', 'uuid'],
    locale: locale.value as StrapiLocale
}));


const [articleResponse, tagResponse] = await Promise.all([articlesRequest, tagDataRequest]);

const { data: articles, pending } = articleResponse;
const { data: tagData } = tagResponse;

const tagInfo = computed(() => tagData.value!.data[0]);

const seoSlugs = useSeoSlugs(tagInfo, 'tagName', 'tagName');
const runtimeConfig = useRuntimeConfig();

useSeoMeta({
    title: () => `${t("tags.meta.title")} ${tagInfo.value.attributes.tagName}`,
    ogTitle: () => `${t("tags.meta.title")} ${tagInfo.value.attributes.tagName}`,
    description: () => `${t("tags.meta.description")} ${tagInfo.value.attributes.tagName}`,
    ogDescription: () => `${t("tags.meta.description")} ${tagInfo.value.attributes.tagName}`,
    ogImage: () => runtimeConfig.public.baseUrl + '/logo.png',
    twitterCard: 'summary_large_image',
    twitterImage: () => runtimeConfig.public.baseUrl + '/logo_twitter_large.png'

});

route.meta.nuxtI18n = seoSlugs.value;

</script>

<template>
    <div>
        <div class="flex flex-col gap-2 container mx-auto mt-3 mb-3" v-if="tagInfo">
            <h1>Articles related to <span style="{ color: tagInfo.attributes.tagColor }">#</span>{{
                tagInfo.attributes.tagName }}</h1>

            <section class="flex-1 grow">
                <template v-if="pending">
                    Loading ...
                </template>

                <template v-if="!pending">
                    <ArticleContainer v-for="(article, index) in articles?.data" :article="article" />
                </template>
            </section>
        </div>
        <div v-if="!tagInfo">
            Not found any articles with this tag :(
        </div>
    </div>
</template>